// extracted by mini-css-extract-plugin
export var errorIcon = "_oy-1";
export var nameLogo = "_oy-0";